/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { JoinLogDto } from '../../models/join-log-dto';

export interface CenterJoinLogControllerJoinUser$Params {

/**
 * 센터 ID
 */
  id: string;
}

export function centerJoinLogControllerJoinUser(http: HttpClient, rootUrl: string, params: CenterJoinLogControllerJoinUser$Params, context?: HttpContext): Observable<StrictHttpResponse<JoinLogDto>> {
  const rb = new RequestBuilder(rootUrl, centerJoinLogControllerJoinUser.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<JoinLogDto>;
    })
  );
}

centerJoinLogControllerJoinUser.PATH = '/api/center-join-log/{id}/join';
